import React, { useMemo } from "react";
import { SelectInput, useTranslate } from "react-admin";

const RepliesSentInput = (props) => {
  const translate = useTranslate();
  const choices = useMemo(
    () =>
      [
        "researcher_yes_expert_no",
        "researcher_no_expert_yes",
        "researcher_yes_expert_yes",
        "researcher_no_expert_no",
      ].map((c) => ({
        id: c,
        name: translate(`ra.replies-sent.${c}`),
      })),
    [translate]
  );

  return <SelectInput {...props} choices={choices} optionText="name" />;
};
export default RepliesSentInput;
